import styled from '@themes/theme'

export const NoticeModalWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 15px;
  z-index: 1;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  .notice-modal-btn {
    width: 100%;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    transform: translateY(1px);
    z-index: 1;
    &:not(.pc) {
      //min-height: 118vw;
    }
  }
  .partnership-video {
    width: 100%;
    height: auto;
    aspect-ratio: 1920 / 1080;
    object-fit: cover;
    margin-bottom: 20px;
    position: relative;
  }
  .box-type-bottom {
    position: relative;
    transform: translateY(-1px);
    z-index: 1;
    ::before {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      content: '';
      width: 100%;
      height: 20px;
      background: #335FC7;
    }
  }
`
